<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="cover-view">
    <div class="cover-view-top" :style="'background-image:url(' + cmsLoadedCoverImg +');'">
      <div v-if="cmsComunications && cmsComunications.code !== 500 && cmsComunications.length !== 0" class="comunication-wrap">
        <div v-for="com in cmsComunications" :key="com._name">
          <span>{{ com['title_' + currentLang] }}</span>
        </div>
      </div>
      <div class="search-container">
        <div class="search-view">
          <SearchInput @search-pressed="searchHandler" />
          <div class="search-view-title" v-html="$t('welcome_to_portal')" />
        </div>
        <div class="sugg-wrap">
          <div v-if="isMobile" class="icon-arrow-rotated" />
          <SearchSugg :filters="thesaurus" />
          <div v-if="isMobile" class="icon-arrow" />
        </div>
      </div>
    </div>
    <div v-if="thesaurus" class="cover-view-bottom">
      <ChartCaruselBlock :thesaurus="thesaurus" />
      <NewsBlock />
      <DataStoriesBlock />
      <CalendarBlock />
    </div>
  </div>
</template>

<script>
import { getThesaurus } from '@/services/api'
import { getCMSCoverImg, getCMSComunications } from '@/services/graphql'
import SearchInput from '../components/SearchInput.vue'
import SearchSugg from '../components/SearchSugg.vue'
import ChartCaruselBlock from '../components/cover/ChartCaruselBlock.vue'
import DataStoriesBlock from '../components/cover/DataStoriesBlock.vue'
import NewsBlock from '../components/cover/NewsBlock.vue'
import CalendarBlock from '../components/cover/CalendarBlock.vue'

/**
 * The home page of the portal.
 * @displayName Cover
 * @example [none]
 */
export default {
  components: {
    SearchInput,
    SearchSugg,
    ChartCaruselBlock,
    DataStoriesBlock,
    NewsBlock,
    CalendarBlock,
  },
  props: {},
  data() {
    return {
      previewStateOption: '',
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.i18n.lang
    },
    cmsLoadedCoverImg() {
      if (this.$store.state.img.imgUrl !== '') {
        return this.$store.state.img.imgUrl
      }
      else if (this.cmsCoverImg !== null && this.$store.state.img.imgUrl === '') {
        this.setStoreImg(this.cmsCoverImg)
        return this.cmsCoverImg
      }
      else return null
    }
  },
  watch: {
    thesaurus() {
      this.previewStateOption = this.thesaurus.theme[0].label
    },
  },
  asyncComputed: {
    cmsComunications() {
      return getCMSComunications()
    },
    cmsCoverImg() {
      return getCMSCoverImg()
    },
    thesaurus() {
      return getThesaurus(this.$store.state.i18n.lang)
    },
  },
  methods: {
    setStoreImg: function (imgSrc) {
      this.$store.dispatch('addImage', imgSrc)
    },
    /**
     * Detect when the user search a new value and update the url
     * @public This is a public method
     * @param {String} value search string value
     */
    searchHandler: function (value) {
      if (value !== '') {
        if (this.$route.params.params !== value) {
          this.$router.push({ name: 'Search', params: { params: value } })
        }
      } else {
        this.$router.push({ name: 'Search' })
      }
    },
    togglePreviewState(saurus) {
      this.previewStateOption = saurus
    },
  },
}
</script>

<style lang="stylus" scoped>
.cover-view
  flex: 1 1 0%

// .cover-view-bottom
// background-color: $bcn-other-light-grey

.comunication-wrap
  position: absolute
  top: 0
  left: 0
  padding: vw(12px) 0
  display: flex
  flex-direction: column
  width: 100%
  justify-content: center
  align-items: center
  background-color: $lighter-blue
  
  span
    color: $grey-dark
    m-font-size(16, 20)
    font-weight: 400

.search-container
  position: relative
  padding: vw(20px)
  width: vw(850px)

  .mobile &
    width: 96%
    
  .sugg-wrap
    display: flex
    wrap: vw(5px)
    align-items: center
    
    .icon-arrow
      m-icon('chevron-right', 28, white)
      
    .icon-arrow-rotated
      m-icon('chevron-right', 28, white)
      transform: rotate(180deg)

.search-view
    
  >>> .search-input-wrapper
    margin-bottom: vw(20px)

.search-view-title
  m-font-size(16, 25)
  margin-bottom: vw(20px)
  color: white
  text-align: center
  font-weight: 400

  .mobile &
    m-font-size(25, 35)

.cover-view-top
  position: relative
  display: flex
  justify-content: center
  align-items: center
  overflow: hidden
  height: 50vh
  background-size: cover
  background-repeat: no-repeat

  &:before
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-image: url("~@/assets/imgs/portada-opacity.png")
    background-size: cover
    background-repeat: no-repeat
    content: ""

.cover-search
  display: flex
  align-items: center
  margin-top: vw(15px)
  padding: vw(5px)
  width: 70%
  height: 40px
  border-radius: 20px
  background-color: $bcn-background-grey
  cursor: pointer
  
</style>
